import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const Wrapper = styled.label`
  position: relative;
  cursor: pointer;
  font-size: 14px;
  line-height: 152.9%;
  user-select: none;
  color: var(--font-color);
`

const StyledCheckbox = styled.input`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;

  &:checked + div {
    font-weight: bold;
    text-decoration: underline;
  }
`

function Checkbox({ field, ...props }) {
  return (
    <Wrapper>
      <StyledCheckbox type="checkbox" {...field} {...props} />
      <div>{props.title}</div>
    </Wrapper>
  )
}

Checkbox.propTypes = {
  title: PropTypes.string,
}

export { Checkbox }
